import { Accordion, Button, Card, Modal, Table } from 'react-bootstrap';
import { Form, Formik } from 'formik';

import PropTypes from 'prop-types';
import FormInput from '../FormInput';
import FormSwitchButton from '../FormSwitchButton';
import useTheme from '../../hooks/useTheme';
import { usePolicyModalHandlers } from './usePolicyModalHandlers';

function PolicyModal({
  show,
  onHide,
  onComplete,
  existingPolicies,
  currentPolicy,
}) {
  const { yupSchema, handleHide } = usePolicyModalHandlers(
    existingPolicies,
    currentPolicy,
    onHide,
  );
  const [theme] = useTheme();

  const policyName = currentPolicy ? currentPolicy.name : '';
  const ip = currentPolicy ? currentPolicy.ipAddressOrRangeNotation : '';

  const enabled = currentPolicy === undefined ? true : currentPolicy.enabled;
  const trusted = currentPolicy === undefined ? true : currentPolicy.trusted;

  return (
    <Modal show={show} onHide={handleHide} centered>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: '1em' }}>
          {currentPolicy ? 'Edit' : 'Add'} device policy
        </Modal.Title>
      </Modal.Header>
      <Formik
        initialValues={{
          ipAddressOrRangeNotation: ip,
          policyName,
          enabledToggle: enabled,
          trustedToggle: trusted,
        }}
        validationSchema={yupSchema}
        onSubmit={(values, actions) => {
          actions.setSubmitting(false);
          onComplete(
            values.policyName,
            values.ipAddressOrRangeNotation,
            values.enabledToggle,
            values.trustedToggle,
            currentPolicy,
          );
        }}
      >
        {({ values, isValid, isSubmitting }) => (
          <Form>
            <Modal.Body>
              <FormSwitchButton name="enabledToggle" label="Enabled" />
              <br />
              <br />
              <FormSwitchButton
                name="trustedToggle"
                label="Trust devices that match this policy"
              />
              <br />

              <FormInput
                name="policyName"
                id="policyName"
                label="Endpoint / Group Name"
              />

              <FormInput
                name="ipAddressOrRangeNotation"
                id="ipAddressOrRangeNotation"
                label="IP Address / Range"
              />
              <Accordion>
                <Card border="light" style={{ border: 0 }}>
                  <Card.Text style={{ margin: 0 }}>
                    <Accordion.Toggle
                      as={Button}
                      variant="link"
                      eventKey="0"
                      style={{ padding: '10px 0', border: 0 }}
                    >
                      What are the accepted IP Address / Range notations?
                    </Accordion.Toggle>
                  </Card.Text>
                  <Accordion.Collapse eventKey="0">
                    <Card.Body>
                      <Table striped bordered>
                        <tbody>
                          <tr>
                            <td>Individual</td>
                            <td>203.0.113.77</td>
                          </tr>
                          <tr>
                            <td>Range</td>
                            <td>203.0.113.0 - 203.0.113.255</td>
                          </tr>
                          <tr>
                            <td>Shortcut Range</td>
                            <td>203.0.113.0 – 255</td>
                          </tr>
                          <tr>
                            <td>CIDR</td>
                            <td>203.0.113.0/24</td>
                          </tr>
                          <tr>
                            <td>Netmask</td>
                            <td>203.0.113.0/255.255.255.0</td>
                          </tr>
                        </tbody>
                      </Table>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
              </Accordion>
            </Modal.Body>
            <Modal.Footer>
              <Button
                type="submit"
                variant={theme?.buttonVariant}
                size="sm"
                disabled={
                  !isValid ||
                  isSubmitting ||
                  !values.ipAddressOrRangeNotation ||
                  !values.policyName
                }
              >
                {currentPolicy ? 'SAVE' : 'ADD'}
              </Button>
              <Button variant={theme?.buttonVariant} size="sm" onClick={onHide}>
                CANCEL
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  );
}

PolicyModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
  onComplete: PropTypes.func,
  existingPolicies: PropTypes.array,
  currentPolicy: PropTypes.object,
};

export default PolicyModal;
